const viewBsnView = {
	/**
	 * Opent het bsn bekijken modal
	 *
	 * @returns {void}
	 */
	init: function () {
		let bsnInputElement = document.getElementById('bsn') ?? false;
		if (false !== bsnInputElement) {
			let modalElement = document.getElementById('modalPrivacyGevoeligeGegevens');
			let bootstrapModal = new bootstrap.Modal(modalElement);
			bootstrapModal.show();
		}
	},
};

export default viewBsnView;
